import LoginService from '../../data/LoginService';

const login = (username: string, password: string, rememberMe: boolean) => LoginService
  .login({ username, password }, rememberMe);

export default login;
